<template>
  <el-dialog title="警告！" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <span>无权访问</span>
    <span slot="footer" class="dialog-footer">
      <router-link to="/">
        <el-button type="primary">确 定</el-button>
      </router-link>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style>
</style>